import _ from "lodash";
import React from "react";
import { RecentSearchList } from "../SearchList/RecentSearchList";
import I18nHOC from "UIComponents/I18nHOC";
import { compose } from "lib/apolloClient";
import classes from "./RecentSearch.scss";
import classNames from "classnames";

const RecentSearch = props => {
  const { data = [], cursor, t, onCursorFocus, onSuggestionClick } = props;

  const recentSearchLabelClasses = classNames({
    ["text-label-3"]: true,
    [classes.recentSearchLabel]: true,
  });

  return _.size(data) ? (
    <div className={classes.recentSearchContainer} style={{ minHeight: 0 }}>
      <div className={recentSearchLabelClasses}>
        {t("integration:recent_searches")}
      </div>
      <div className={classes.recentSearchListContainer}>
        <RecentSearchList
          data={data}
          cursor={cursor}
          onSelectItem={onSuggestionClick}
          onCursorFocus={onCursorFocus}
        />
      </div>
    </div>
  ) : null;
};

export default compose(I18nHOC({ resource: ["integration"] }))(RecentSearch);
